<ion-item class="proto-item">
  <ion-select
    [label]="'TERM.LANGUAGE' | translate"
    [(ngModel)]="currentLanguage"
    (ionChange)="changeLanguage($event)"
    [okText]="'BUTTON.OK' | translate"
    [cancelText]="'BUTTON.CANCEL' | translate">

    @for (language of availableLanguages; track language) {
      <ion-select-option
        [value]="language">
        {{ 'TERM.LANGUAGES.' + language | translate }}
      </ion-select-option>
    }
  </ion-select>
</ion-item>
<ion-item></ion-item><!-- hotfix to prevent missing bottom border on proto-item -->
